import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { PopupBaseComponent } from '../popup-base/popup-base.component';
import { ButtonComponent, ButtonType } from '../../button/button.component';
import { InfoPopupModel } from './info-popup.model';
import { LayoutStore, LayoutStoreType } from '../../../../core/store/layout.store';

@Component({
    selector: 'juyo-info-popup',
    styleUrl: 'info-popup.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PopupBaseComponent, ButtonComponent],
    template: `
        <juyo-popup-base [popupId]="model().id" [showHeader]="hasHeader()">
            @if (hasHeader()) {
                <span slot="header">{{ model().header }}</span>
            }

            <p slot="body" class="content">{{ model().content }}</p>

            <ng-container slot="footer">
                <juyo-button [buttonType]="ButtonType.PURPLE" (clicked)="onClose()"> {{ model().buttonText }} </juyo-button>
            </ng-container>
        </juyo-popup-base>
    `,
})
export class InfoPopupComponent {
    public model = input.required<InfoPopupModel>();

    protected readonly ButtonType = ButtonType;

    protected hasHeader = computed(() => !!this.model().header);

    private layoutStore: LayoutStoreType = inject(LayoutStore);

    protected onClose(): void {
        this.layoutStore.closePopup(this.model().id);
    }
}
